// extracted by mini-css-extract-plugin
module.exports = {"button":"Avatar_button__Shqgf","photoPickerDiv":"Avatar_photoPickerDiv__CZF1U","avatar":"Avatar_avatar__ecp45"};